const studentNameCollator = new Intl.Collator(undefined, {
  sensitivity: "base",
  numeric: true,
});

function defaultNameSelector(item) {
  if (!item) return "";
  return item.Student ? item.Student.fullName : item.fullName;
}

export default function sortStudentsByName(students, nameSelector = defaultNameSelector) {
  return (Array.isArray(students) ? students : [])
    .map((student, index) => ({ student, index }))
    .sort((left, right) => {
      const leftName = String(nameSelector(left.student) || "").trim();
      const rightName = String(nameSelector(right.student) || "").trim();
      const nameOrder = studentNameCollator.compare(leftName, rightName);

      return nameOrder || left.index - right.index;
    })
    .map(({ student }) => student);
}
